import { TOGGLE_THEME } from "../constants";

export const toggleTheme = () => {
    return {
        type: TOGGLE_THEME,
    };
};
